import { Link } from "react-router-dom";
import { BrandMark } from "../components/Nav";

export default function PaymentCancel() {
  return (
    <div
      className="min-h-screen bg-ground text-ink flex flex-col items-center justify-center px-6"
      data-testid="payment-cancel-page"
    >
      <BrandMark className="w-10 h-10 text-gold mb-8" />
      <span className="mono-tag text-xs uppercase text-gold tracking-widest mb-4">
        THE ABSTRACTS
      </span>
      <h1 className="text-2xl md:text-4xl font-bold uppercase text-white mb-3 text-center">
        Checkout Cancelled
      </h1>
      <p className="text-sm text-slate-400 text-center max-w-md">
        No charge was made. The piece remains available in the catalog.
      </p>
      <Link
        to="/"
        className="mt-10 px-6 py-3.5 bg-gold text-black font-semibold uppercase tracking-wider text-xs hover:bg-gold-hover transition-colors"
        data-testid="cancel-back-to-gallery-link"
      >
        Back to Gallery
      </Link>
    </div>
  );
}
